import { useState } from "react"

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"

function useAcceptDialog() {
  const [resolve, setResolve] = useState<(() => void) | null>(null)
  const [open, isOpen] = useState(false)
  const [title, setTitle] = useState("")
  const [text, setText] = useState("")

  const handleClose = (accepted: boolean) => {
    isOpen(false)
    if (accepted && resolve) {
      resolve()
    }
    setResolve(null)
  }

  const openDialog = (title: string, text: string) => {
    isOpen(true)
    setTitle(title)
    setText(text)
    return new Promise<void>(res => {
      setResolve(() => () => res())
    })
  }

  return {
    Dialog: () => (
      <Dialog
        sx={{ ".MuiDialog-paper": { minWidth: 300, pr: 2 } }}
        open={open}
        onClose={() => handleClose(false)}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ mb: 2 }}>
          <Button onClick={() => handleClose(false)} variant="contained" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    ),
    openDialog,
  }
}

export { useAcceptDialog }
